/**
 * Component copied from S2 until we have moved over their code to this repo.
 */
class AdjustableStateComponent {
    constructor(state) {
        this.state = state;
        this.typeId = AdjustableStateComponent.id;
        this.doStoreInSnapshot = true;
        this.serializable = false;
    }
    eq(_other) {
        return false;
    }
}
AdjustableStateComponent.id = 3004;
export default AdjustableStateComponent;
//# sourceMappingURL=AdjustableStateComponent.js.map